import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";

const SEORedirects = () => {
	const [seoRedirects, setSeoRedirects] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "عناصر اعادة التوجيه",
				breadcrumb: "عناصر اعادة التوجيه",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة عنصر اعادة توجيه",
					link: "/seoRedirects/addSeoRedirects",
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/seoRedirects`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setSeoRedirects(response?.data?.data?.seoRedirects);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const cleanAndDecodeUrl = url => {
		try {
			// Decode Arabic or encoded characters
			let decoded = decodeURIComponent(url);

			// Remove extra slashes (but keep the "//" after https:)
			decoded = decoded.replace(/([^:]\/)\/+/g, "$1");

			return decoded;
		} catch (err) {
			console.error("Invalid URL:", err);
			return url; // return original if something goes wrong
		}
	};

	const handleConfrimDelete = id => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteSeoLink(id),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteSeoLink = id => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/seoRedirects/${id}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
				toast.success("تم حذف العنصر بنجاح!");
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		{
			name: "المصدر",
			selector: "source",
			sortable: true,
			width: "30%",
			style: {
				direction: "ltr",
				paddingBlock: "20px",
				textAlign: "left",
			},
			cell: row => (
				<div title={row?.source}>
					{row?.source?.length > 50
						? `${row?.source?.slice(0, 50)}...`
						: row?.source}
				</div>
			),
		},
		{
			name: "الهدف",
			selector: "destination",
			sortable: true,
			grow: 2,
			style: {
				direction: "ltr",
				paddingBlock: "20px",
				textAlign: "left",
			},
			cell: row => (
				<div title={decodeURIComponent(row?.destination)}>
					{cleanAndDecodeUrl(row?.destination)}
				</div>
			),
		},

		{
			name: "كود اعادة التوجيه",
			selector: "redirectCode",
			sortable: true,
			style: {
				justifyContent: "center",
			},
			width: "140px",
		},

		{
			name: "الاعدادت",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					{checkPermissions(["contact-list"]) && (
						<li className="list-inline-item">
							<Link
								className="bt bt-success bt-sm"
								to={`/seoRedirects/editSeoRedirects/${row.id}`}
							>
								<i className="fas fa-edit"></i>
							</Link>
						</li>
					)}
					{checkPermissions(["contact-delete"]) && (
						<li className="list-inline-item">
							<button
								className="bt bt-danger bt-sm"
								onClick={() => handleConfrimDelete(row.id)}
								type="button"
								aria-label="delete"
							>
								<i className="fas fa-trash"></i>
							</button>
						</li>
					)}
				</ul>
			),
			width: "150px",
		},
	];

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={seoRedirects}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default SEORedirects;
export const cleanUrl = url =>
	decodeURI(decodeURI(url?.split(".sa")?.pop()?.replaceAll(" ", "")));
